import { SubstituteContent as SubstituteContentComponent } from './SubstituteContent.component';
import { connector } from './SubstituteContent.connector';

export const SubstituteContent = connector(SubstituteContentComponent);
